import React from "react";
import CustomizedAvatar from "../commons/CircularAvatar/CustomizedAvatar";
import { PeopleOnLeaveListType } from "../../redux/mySpace/mySpaceTypes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BoxLoader from "../commons/BoxLoader/BoxLoader";
type AppProps = {
  data: PeopleOnLeaveListType[] | [];
  handleTogglePeopleOnLeaveModal: () => void;
  fetching: boolean;
};
const PeopleOnLeave = ({
  data,
  handleTogglePeopleOnLeaveModal,
  fetching,
}: AppProps) => {
  const filterData = data?.slice(0, 4);
  return (
    <>
      <div className="boxs p-3" style={{ height: "150px" }}>
        {fetching ? (
          <BoxLoader style={{ height: "100%" }} />
        ) : (
          <>
            <div className="mb-3 d-flex justify-content-between align-items-center">
              <div style={{ fontWeight: 600, fontSize: "16px" }}>
                People on Leave
              </div>
              <div>
                <button
                  onClick={handleTogglePeopleOnLeaveModal}
                  className="btn btn-outline"
                  disabled={data?.length === 0}
                >
                  View All
                </button>
              </div>
            </div>
            <div
              className="d-flex flex-start align-items-center"
              style={{ gap: "1.5%" }}
            >
              {filterData?.length
                ? filterData?.map((el: PeopleOnLeaveListType) => {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 250 }}
                        overlay={
                          <Tooltip id="button-view-filter-invoice">
                            <>
                              <div className="d-flex flex-column">
                                <span>
                                  {`${el?.first_name ? el?.first_name : ""} ${
                                    el?.last_name ? el?.last_name : ""
                                  }`}
                                </span>
                                {!!el?.job_title?.length && (
                                  <span>Job Title : {el?.job_title}</span>
                                )}
                                {!!el?.department?.length && (
                                  <span>Department : {el?.department}</span>
                                )}

                                <span>
                                  Leave : {el?.start_date} to {el?.end_date}
                                </span>
                              </div>
                            </>
                          </Tooltip>
                        }
                      >
                        <div>
                          <CustomizedAvatar
                            name={`${el?.first_name ? el?.first_name : ""} ${
                              el?.last_name ? el?.last_name : ""
                            }`}
                            image={el?.profile_pic?.file_url}
                            style={{ width: "56px", fontSize: "20px" }}
                          />
                        </div>
                      </OverlayTrigger>
                    );
                  })
                : ""}
            </div>
            {data?.length === 0 ? (
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: 500,
                }}
                className="text-center mt-2"
              >
                No Data found
              </div>
            ) : (
              ""
            )}
          </>
        )}
      </div>
    </>
  );
};

export default PeopleOnLeave;
